const ServerError: React.FC = () => {
    return (
        <>
        </>
    )
}

export default ServerError;